import { useCallback } from 'react';

import type { TriggerFn } from '@lexical/react/LexicalTypeaheadMenuPlugin';

const useTypeaheadTriggerMatch = (
  trigger: string,
  { minLength = 1, maxLength = 75 }: { minLength?: number; maxLength?: number },
): TriggerFn => {
  return useCallback(
    (text: string) => {
      const TypeaheadTriggerRegex = new RegExp(
        /* prettier-ignore */
        '(^|\\s|\\()(' +
          '[' +
          trigger +
          ']' +
          '((.*){0,' +
          maxLength +
          '})' +
          ')$',
      );
      const match = TypeaheadTriggerRegex.exec(text);
      if (match !== null) {
        const maybeLeadingWhitespace = match[1];
        const matchingString = match[3];
        if (matchingString.length >= minLength) {
          return {
            leadOffset: match.index + maybeLeadingWhitespace.length,
            matchingString,
            replaceableString: match[2],
          };
        }
      }
      return null;
    },
    [maxLength, minLength, trigger],
  );
};

export default useTypeaheadTriggerMatch;
